import type { Dictionary } from './de';
import { trCampaigns } from './tr.campaigns';
import { trDialer } from './tr.dialer';
import { trPlatform } from './tr.platform';
import { trUi } from './tr.ui';
import { trTelephony } from './tr.telephony';

export const tr: Dictionary = {
  ...trCampaigns,
  ...trUi,
  ...trDialer,
  ...trPlatform,
  ...trTelephony,
  'app.name': 'Autodialer',
  'app.loading': 'Bir saniye …',

  'action.login': 'Giriş yap',
  'action.logout': 'Çıkış yap',
  'action.save': 'Kaydet',
  'action.cancel': 'İptal',
  'action.back': 'Geri',
  'action.create': 'Oluştur',
  'action.showPassword': 'Parolayı göster',
  'action.hidePassword': 'Parolayı gizle',

  'login.title': 'Giriş yap',
  'login.identifier': 'E-posta adresi veya kullanıcı adı',
  'login.identifierHint': 'Hesap sahipleri e-posta adresiyle, temsilciler kullanıcı adıyla giriş yapar.',
  'login.password': 'Parola',
  'login.forgotPassword': 'Parolanızı mı unuttunuz?',
  'login.noAccount': 'Hesabınız yok mu? Hemen kaydolun',
  'login.platformTitle': 'Yönetim',
  'login.email': 'E-posta adresi',

  'register.title': 'Hesap oluştur',
  'register.email': 'E-posta adresi',
  'register.password': 'Parola',
  'register.passwordConfirmation': 'Parolayı tekrarlayın',
  'register.submit': 'Hesap oluştur',
  'register.haveAccount': 'Zaten hesabınız var mı? Giriş yapın',
  'register.successTitle': 'Hoş geldiniz',
  'register.successText': 'Hesabınız hazır. Şimdi giriş yapabilirsiniz.',
  'register.customerNumber': 'Müşteri numaranız',
  'register.customerNumberHint': 'Destek ile iletişime geçerken bu numaraya ihtiyacınız olacak.',

  'forgot.title': 'Parolamı unuttum',
  'forgot.text': 'E-posta adresinizi girin. Bu adrese ait bir hesap varsa, yeni parola belirlemeniz için bir bağlantı göndeririz.',
  'forgot.submit': 'Bağlantı iste',
  'forgot.done': 'Bu adrese ait bir hesap varsa e-posta yola çıktı. Lütfen gelen kutunuza bakın.',
  'forgot.callerHint': 'Temsilci hesaplarında parola sıfırlama yoktur. Lütfen yöneticinize başvurun.',

  'reset.title': 'Yeni parola belirle',
  'reset.password': 'Yeni parola',
  'reset.submit': 'Parolayı kaydet',
  'reset.done': 'Parolanız kaydedildi. Şimdi giriş yapabilirsiniz.',

  'home.greeting': 'Hoş geldiniz',
  'home.role.owner': 'Hesap sahibi',
  'home.role.admin': 'Yönetici',
  'home.role.caller': 'Temsilci',
  'home.customerNumber': 'Müşteri numarası',
  'home.nextSteps': 'Kampanyalar, kayıtlar ve arama bölümleri sonraki adımlarda gelecek.',

  'nav.home': 'Başlangıç',
  'nav.callers': 'Temsilciler',
  'nav.account': 'Ayarlar',

  'callers.title': 'Temsilciler',
  'callers.intro': 'Temsilcileriniz için erişim hesaplarını burada oluşturursunuz.',
  'callers.username': 'Kullanıcı adı',
  'callers.password': 'Parola',
  'callers.add': 'Temsilci ekle',
  'callers.empty': 'Henüz temsilci yok.',
  'callers.isAdmin': 'Yönetici',
  'callers.makeAdmin': 'Yönetici yap',
  'callers.revokeAdmin': 'Yönetici yetkisini kaldır',
  'callers.deactivate': 'Erişimi kapat',
  'callers.activate': 'Erişimi aç',
  'callers.newPassword': 'Yeni parola belirle',
  'callers.newPasswordSaved': 'Yeni parola kaydedildi.',
  'callers.inactive': 'Kapalı',
  'callers.you': 'Siz',

  'account.title': 'Ayarlar',
  'account.name': 'Firma veya hesap adı',
  'account.nameSaved': 'Kaydedildi.',
  'account.email': 'E-posta adresi',
  'account.customerNumber': 'Müşteri numarası',
  'account.balance': 'Bakiye',
  'account.pricePerMinute': 'Görüşme dakikası ücreti',
  'account.changePassword': 'Parolayı değiştir',
  'account.currentPassword': 'Mevcut parola',
  'account.newPassword': 'Yeni parola',
  'account.passwordSaved': 'Parolanız değiştirildi.',
  'account.language': 'Dil',
  'account.delete': 'Hesabı kapat',
  'account.deleteWarning':
    'Bu işlem hesabınızı kapatır. Siz ve temsilcilerınız artık giriş yapamaz. Bu adım geri alınamaz.',
  'account.deleteConfirm': 'Evet, hesabı kalıcı olarak kapat',
  'account.deletePassword': 'Onaylamak için lütfen parolanızı girin.',

  'session.endedTitle': 'Oturumunuz kapatıldı',
  'session.ended.replaced': 'Başka bir pencerede giriş yaptınız. Güvenlik nedeniyle aynı anda yalnızca bir oturum açık olabilir.',
  'session.ended.idle': 'Bir saat boyunca işlem yapmadınız. Lütfen tekrar giriş yapın.',
  'session.ended.suspended': 'Hesap kilitli. Lütfen destek ile iletişime geçin.',
  'session.ended.deleted': 'Bu hesap kapatıldı.',
  'session.ended.password_changed': 'Parolanız değiştirildi. Lütfen tekrar giriş yapın.',
  'session.ended.logout': 'Lütfen giriş yapın.',

  'error.auth.invalid_credentials': 'Bilgiler eşleşmiyor. Lütfen tekrar deneyin.',
  'error.auth.too_many_attempts': 'Çok fazla deneme. Lütfen iki dakika bekleyip tekrar deneyin.',
  'error.auth.account_suspended': 'Hesap kilitli. Lütfen destek ile iletişime geçin.',
  'error.auth.user_inactive': 'Bu erişim kapatılmış. Lütfen yöneticinize başvurun.',
  'error.auth.required': 'Lütfen giriş yapın.',
  'error.auth.admin_required': 'Bu bölüm için yönetici yetkisi gerekir.',
  'error.registration.email_taken': 'Bu e-posta adresi için zaten bir hesap var.',
  'error.registration.invalid_email': 'Lütfen geçerli bir e-posta adresi girin.',
  'error.registration.password_mismatch': 'İki parola birbiriyle eşleşmiyor.',
  'error.registration.password_required': 'Lütfen bir parola girin.',
  'error.caller.username_taken': 'Bu kullanıcı adı zaten alınmış. Lütfen başka bir ad seçin.',
  'error.caller.invalid_username': 'Kullanıcı adı yalnızca harf, rakam, nokta, tire ve alt çizgi içerebilir.',
  'error.caller.password_required': 'Lütfen bir parola belirleyin.',
  'error.caller.not_found': 'Bu erişim bulunamadı.',
  'error.caller.owner_keeps_admin': 'Hesap sahibinin yönetici yetkisi kaldırılamaz.',
  'error.caller.owner_stays_active': 'Hesap sahibinin erişimi kapatılamaz.',
  'error.password.current_wrong': 'Mevcut parola doğru değil.',
  'error.password.reset_token_invalid': 'Bu bağlantı artık geçerli değil. Lütfen yenisini isteyin.',
  'error.account.only_owner_may_delete': 'Hesabı yalnızca hesap sahibi kapatabilir.',
  'error.account.confirmation_required': 'Lütfen açıkça onaylayın.',
  'error.request.invalid': 'Lütfen girdilerinizi kontrol edin.',
  'error.unknown': 'Bu işlem gerçekleşmedi. Lütfen tekrar deneyin.',
  'error.offline': 'Uygulamaya şu anda ulaşılamıyor. Lütfen daha sonra tekrar deneyin.',
};
